import { Color } from '../../../types/color'

export const hProgressBgMap: Record<Color, string> = {
  blue: '#6494ff',
  green: '#60C87D',
  grey: '#DBE3F4',
}
